
import { Component, Vue } from "vue-property-decorator";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";


import ChangePassword from "@/layout/components/ChangePassword/index.vue";

@Component({
  name: "Navbar",
  components: {
    ChangePassword,
    Breadcrumb,
    Hamburger
  }
})
export default class extends Vue {

  showChangePassword = false;

  get sidebar() {
    return this.$store.getters['app/sidebar'];
  }

  get device() {
    return this.$store.getters['app/device']
  }

  get avatar() {
    return this.$store.getters['user/avatar'];
  }

  get userName() {
    return this.$store.getters['user/name'];
  }

  private toggleSideBar() {
    this.$store.dispatch('app/toggleSidebar',false);
  }

  private async selectStore() {
    await this.$router.push({ path: "/selectStore" });
  }

  private async logout() {
    this.$store.commit('user/LOGOUT');
    this.$router.push('/account/login');
  }

  openChangePasswordDialog(){
    (this.$refs.changePassword as any).show = true;
  }
}
